import { render } from "./carouselSettingsimg.vue?vue&type=template&id=1767c1dc&scoped=true"
import script from "./carouselSettingsimg.vue?vue&type=script&lang=js"
export * from "./carouselSettingsimg.vue?vue&type=script&lang=js"

import "./carouselSettingsimg.vue?vue&type=style&index=0&id=1767c1dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1767c1dc"]])

export default __exports__